var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t('views.medicalpersons.affiliations.detail.title')))]),_c('entity-detail-table',{attrs:{"entityKey":_vm.eParent.key,"entityId":_vm.eParent.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }